const logoBarSwiperContainers = document.querySelector('.logo-bar-swiper');
const slidesPerView = logoBarSwiperContainers.dataset.slidesPerView || 1;

const breakpoint = window.matchMedia('(min-width: 750px');
let swiperSlider;

const breakpointChecker = function () {
  if (breakpoint.matches === true) {
    if (swiperSlider !== undefined) swiperSlider.destroy(true, true);
    return;
  } else if (breakpoint.matches === false) {
    return enableSwiper();
  }
};

const enableSwiper = function () {
  swiperSlider = new Swiper('.logo-bar-swiper', {
    slidesPerView: slidesPerView,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 2500,
    },
  });
};

breakpoint.addEventListener('change', breakpointChecker);
breakpointChecker();